import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { notify } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";

const urlBaseRepuestos = process.env.REACT_APP_TMAN_API + '/Replacement'
const urlBaseKardex = process.env.REACT_APP_TMAN_API + '/Store'

export const useKardex = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa
    const codUsuario = stateUser.codUsuario
    
    const [elementosKardex,setElementosKardex] = useState([])
    const [almacenesCombo,setAlmacenesCombo] = useState([])
    const [productos,setProductos] = useState([])
    
    const listarKardex = async (codRepuesto,codAlmacen) => {
        const response = await AuthFetch({
            url: urlBaseKardex + '/kardex?' + new URLSearchParams({
                CodEmpresa: codEmpresa,
                CodRepuesto: codRepuesto,
                CodAlmacen: codAlmacen
            })
        })
        if(response.isValid){
            setElementosKardex(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarAlmacenesParaCombo = async () => {
        const response = await AuthFetch({
            url: urlBaseKardex + '/combos?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                CodUsuarioAccion: codUsuario
            })
        })
        if(response.isValid){
            setAlmacenesCombo(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const autocompleteProductos = async (texto,codAlmacen) => {
        const response = await AuthFetch({
            url: urlBaseRepuestos + '/productDetailStore?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                texto: texto,
                codAlmacen: codAlmacen
            })
        })
        if(response.isValid){
            setProductos(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }
    
    
    return {
        listarKardex,
        elementosKardex,
        listarAlmacenesParaCombo,
        almacenesCombo,
        autocompleteProductos,
        productos
    }
}
